(function () {
	'use strict';

	angular
		.module('wizard-future7.directives')
		.directive('ctaTeste', CtaTeste)

	/** @ngInject */
	function CtaTeste(PATHS) {
		function CtaTesteController() {
			const vm = this;

			vm.closeCta = () => {
				vm.isOpen = false;
			}

			init();

			function init() {
				vm.isOpen = true;
			}

		}

		return {
			bindToController: true,
			controller: CtaTesteController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/cta-teste/cta-teste.html`,
			scope: {}
		}
	}
}());